//信件
EmailManager = xClass("EmailManager");
let _instance = null;
EmailManager.getInstance = function () {
    if (!_instance) {
        _instance = EmailManager.create();
    }
    return _instance;
}
EmailManager.prototype.ctor = function () {
    let self = this;
    self.mails = [];
    self.cacheMails = [];//把邮件详情缓存起来，当下一次拉取全部信件时，赋值
    self.lastGetInfoTime = 0;
    //主界面和子节点使用
    self.isBusy = false;
    //主界面panel
    self.mainPanel = null;
    //打点session
    self.dcSession = "";
}

//强制刷新
EmailManager.prototype.forceGetInfo = function () {
    let self = this;
    self.cacheMails = JSON.parse(JSON.stringify(self.mails));
    self.getInfo().then(() => {
        self.changeMultiMails(self.cacheMails, true);
        self.cacheMails = [];
        //
        let homeScene = require("clover/scene/HomeScene").getInstance()
        if (homeScene.btnLayer) {
            homeScene.btnLayer.updateBoxPrompt()
        }
    })
}

//获取活动信息
EmailManager.prototype.getInfo = function (showMailIds = []) {
    let self = this;
    const isNull = !showMailIds || !showMailIds.length;
    return new Promise((resolve, reject) => {
        let onSuccess = function (evt) {
            if (evt && evt.data) {
                const data = evt.data;
                let mailSortInfos = data.mailSortInfos;
                if (isNull) {
                    if (!mailSortInfos || !$len(mailSortInfos)) {
                        mailSortInfos = [];
                    }
                    self.sortMail(mailSortInfos);
                    self.lastGetInfoTime = Localhost.timeInSec();
                }
                self.changeMultiMails(data.showMails);
                resolve(data);
            } else {
                reject(evt);
            }
        }

        let onFail = function (evt) {
            Toast.make(curryQuickGetErrorText(evt.data));
            reject(evt);
        }

        let http = MailListHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(showMailIds);
    })
}

//打开信件
EmailManager.prototype.mailOpen = function (mailId) {
    let self = this;
    return new Promise((resolve, reject) => {
        let onSuccess = function (evt) {
            if (evt && evt.data) {
                let data = evt.data;
                data.openFlag = 1;
                self.changeMail(mailId, data);
                resolve(data);
            } else {
                reject(evt);
            }
        }

        let onFail = function (evt) {
            if (self.needDelMail(evt)) {
                self.delMail(mailId);
                self.refreshMails();
            }
            Toast.make(curryQuickGetErrorText(evt.data));
            reject(evt);
        }

        let http = MailOpenHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(mailId);
    })
}

//接受信件
EmailManager.prototype.mailAccept = function (mailId) {
    let self = this;
    return new Promise((resolve, reject) => {
        let onSuccess = function (evt) {
            if (evt && evt.data) {
                let data = evt.data;
                let mailExpireInfo = data.mailExpireInfo;
                mailExpireInfo.openFlag = 1;
                mailExpireInfo.acceptFlag = 1;
                mailExpireInfo.deletableFlag = 1;
                self.changeMail(mailId, mailExpireInfo);
                resolve(data);
            } else {
                reject(evt);
            }
        }

        let onFail = function (evt) {
            if (self.needDelMail(evt)) {
                self.delMail(mailId);
                self.refreshMails();
            }
            Toast.make(curryQuickGetErrorText(evt.data));
            reject(evt);
        }

        let http = MailAcceptHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(mailId);
    })
}

//删除信件
EmailManager.prototype.mailDelete = function (mailId) {
    let self = this;
    return new Promise((resolve, reject) => {
        let onSuccess = function (evt) {
            if (evt && evt.data) {
                const data = evt.data;
                self.delMail(mailId);
                resolve(data);
            } else {
                reject(evt);
            }
        }

        let onFail = function (evt) {
            Toast.make(curryQuickGetErrorText(evt.data));
            reject(evt);
        }

        let http = MailDeleteHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(mailId);
    })
}

//批量删除信件
EmailManager.prototype.mailBatchDelete = function (mailTypes = []) {
    let self = this;
    return new Promise((resolve, reject) => {
        let onSuccess = function (evt) {
            if (evt && evt.data) {
                const data = evt.data;
                if (data.mailIds) {
                    for (let i = 0; i < data.mailIds.length; i++) {
                        const mailId = data.mailIds[i];
                        if (mailId) {
                            self.delMail(mailId);
                        }
                    }
                }

                resolve(data);
            } else {
                reject(evt);
            }
        }

        let onFail = function (evt) {
            Toast.make(curryQuickGetErrorText(evt.data));
            reject(evt);
        }

        let http = MailBatchDeleteHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(mailTypes);
    })
}

//批量领取信件奖励
EmailManager.prototype.mailBatchAccept = function (mailTypes = []) {
    let self = this;
    return new Promise((resolve, reject) => {
        let onSuccess = function (evt) {
            if (evt && evt.data) {
                const data = evt.data;
                if (data.mailExpireInfos) {
                    for (let i = 0; i < data.mailExpireInfos.length; i++) {
                        let mailExpireInfo = data.mailExpireInfos[i];
                        if (mailExpireInfo && mailExpireInfo.mailId) {
                            mailExpireInfo.openFlag = 1;
                            mailExpireInfo.acceptFlag = 1;
                            mailExpireInfo.deletableFlag = 1;
                            let mail = self.changeMail(mailExpireInfo.mailId, mailExpireInfo);
                            if (mail && mail.mailType == EmailType.ENERGY_HELP) {
                                self.delMail(mail.mailId);
                            }
                        }
                    }
                }

                resolve(data);
            } else {
                reject(evt);
            }
        }

        let onFail = function (evt) {
            Toast.make(curryQuickGetErrorText(evt.data));
            reject(evt);
        }

        let http = MailBatchAcceptHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(mailTypes);
    })
}

//通过与服务端交互返回的报错码判断是否需要删除该邮件
EmailManager.prototype.needDelMail = function (evt = {}) {
    const retCode = evt.data;
    if (retCode == 763608 || retCode == 763601) {
        return true;
    }
    return false;
}

//修改多封邮件
EmailManager.prototype.changeMultiMails = function (showMails, isCache = false) {
    let self = this;
    if (showMails && $len(showMails)) {
        for (let i = 0; i < showMails.length; i++) {
            let mail = showMails[i];
            if (mail && mail.mailId) {
                self.changeMail(mail.mailId, mail, isCache);
            }
        }
    }
}

//修改邮件内容、状态。 如果数据来自Cache,则优先使用服务端数据
EmailManager.prototype.changeMail = function (mailId, data, isCache = false) {
    let self = this;
    for (let i = 0; i < self.mails.length; i++) {
        let mail = self.mails[i];
        if (mail && mail.mailId == mailId) {
            for (let key in data) {
                let value = data[key]
                if ($null(value) || (isCache && !$null(mail[key]))) {
                    continue
                }
                mail[key] = value
            }
            self.sortMail(self.mails);
            return mail;
        }
    }
    return null;
}

//删除邮件
EmailManager.prototype.delMail = function (mailId) {
    let self = this;
    for (let i = 0; i < self.mails.length; i++) {
        let mail = self.mails[i];
        if (mail && mail.mailId === mailId) {
            self.mails.splice(i, 1);
            self.sortMail(self.mails);
            break;
        }
    }
}
//排序邮件
EmailManager.prototype.sortMail = function (mailList = []) {
    let self = this;
    let list = [];
    for (let i = 0; i < mailList.length; i++) {
        let mail = mailList[i];
        if (mail && ((mail.mailType && mail.mailType <= EmailType.WX_GAME_CIRCLE) || !mail.mailType)) {
            list.push(mail);
        }
    }
    let getValue = function (temp) {
        return -temp.deletableFlag * 10000 + temp.mailId;
    }
    list.sort((a, b) => {
        return getValue(b) - getValue(a);
    });

    self.mails = list;
}

//刷新主界面列表
EmailManager.prototype.refreshMails = function () {
    let self = this;
    if (self.mainPanel) {
        self.mainPanel.refreshUI();
    }
}

//是否展示红点
EmailManager.prototype.hasRedDot = function () {
    let self = this;
    let isPrompt = false;
    let mails = self.mails;
    for (let i = 0; i < mails.length; i++) {
        let mail = mails[i];
        if (mail && mail.mailType && !mail.deletableFlag) {
            isPrompt = true;
            break;
        }
    }
    return isPrompt;
}

/** 打开面板 - 主页面 */
EmailManager.prototype.openPanel = function (cb, cbClose) {
    let self = this;
    const EmailPanel = require("./EmailPanel");
    function onResLoad() {
        let panel = EmailPanel.create();
        self.mainPanel = panel;
        panel.on(BasePanelEvent.Close, function () {
            self.mainPanel = null;
            cbClose && cbClose();
        });
        cb && cb(panel);
    }

    function onResLoadFail(evt) {
        cc.log("unable to create EmailPanel. load res failed.", evt);
        cb && cb();
    }
    EmailPanel.preloadRes(onResLoad, onResLoadFail, onResLoadFail, true);
}

/** 打开面板 - 主页面 */
EmailManager.prototype.openDetailPanel = function (data, cb, cbClose) {
    let self = this;
    const EmailDetailPanel = require("./EmailDetailPanel");
    function onResLoad() {
        let panel = EmailDetailPanel.create(data);
        cb && cb(panel);
        cbClose && cbClose();
    }

    function onResLoadFail(evt) {
        cc.log("unable to create EmailDetailPanel. load res failed.", evt);
        cb && cb();
    }
    EmailDetailPanel.preloadRes(onResLoad, onResLoadFail, onResLoadFail, true);
}

EmailManager.prototype.getDcSTime = function (timeStamp = 0) {
    let now = Localhost.timeInSec();
    return Math.round((timeStamp / 1000 - now) / 60);
}

EmailManager.prototype.getDctype = function (data) {
    let type = 0;
    if (data.deletableFlag) {
        type = 2;
    } else if (data.openFlag) {
        type = 1;
    }
    return type;
}

EmailManager.prototype.dcSimple = function (subCategory, params = {}, category) {
    let self = this;
    if (!params.session) {
        params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    }
    DCAssist.userTrack(category ? category : ModuleName.MESSAGE, subCategory, params);
    return params;
}

